import { createFileRoute } from '@tanstack/react-router'
import ImportsContainer from 'Imports/containers/ImportsContainer'

import { Guard, importClaims } from './-guard'

export const Route = createFileRoute('/imports')({
    component: () => (
        <Guard claims={importClaims}>
            <ImportsContainer />
        </Guard>
    ),
})
